import React from 'react';
import ScreenDesignerListHoc from "../../../../../../../../../HocHelpers/ScreenDesignerListHoc";
import BarRechart from "./ChartsTypes/BarRechart";
import LineRechart from "./ChartsTypes/LineRechart";
import PieRechart from "./ChartsTypes/PieRechart";
import ComposedRechart from "./ChartsTypes/ComposedRechart";
import {useSelector} from "react-redux";


const ScreenCharts = (props) => {
    const {chartProps: {type} = {}} = props;
    const {userLanguage} = useSelector(state => state.app);
    switch (type) {
        case 'barRechart':
            return <BarRechart
                userLanguage={userLanguage}
            />;
        case 'lineRechart':
            return <LineRechart
                userLanguage={userLanguage}
            />;
        case 'pieRechart':
            return <PieRechart
                userLanguage={userLanguage}
            />;
        case 'composedRechart':
            return <ComposedRechart
                userLanguage={userLanguage}
            />;
        default:
            return <BarRechart
                userLanguage={userLanguage}
            />
    }
}

export default ScreenDesignerListHoc(ScreenCharts)

